export default {
    zoom: 1,
    cropXRatio: 1,
    cropYRatio: 1,
    version: 1
};



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/image-inline-editor/core/DefaultPayload.ts
 **/